import classNames from 'classnames';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

export type StarterHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  filteredCount: number;
  totalCount: number;
  hasSelectedTags: boolean;
  isSortOpen: boolean;
  isFilterOpen: boolean;
  hasAvailableTags: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onToggleSort: () => void;
  onToggleFilter: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function StarterHeader({
  style,
  isOpen,
  filteredCount,
  totalCount,
  hasSelectedTags,
  isSortOpen,
  isFilterOpen,
  hasAvailableTags,
  allHidden,
  onToggle,
  onToggleSort,
  onToggleFilter,
  onHide,
  onUnhide,
}: StarterHeaderProps): JSX.Element {
  return (
    <div
      className={classNames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        {isOpen ? (
          <i className="fas fa-chevron-down" />
        ) : (
          <i className="fas fa-chevron-down fa-rotate-270" />
        )}
        &nbsp;
        <div className="starter-list-header-item-label">
          {t('list.STARTERS')}
          {hasSelectedTags && (
            <span className="starter-list-header-item-info">
              {filteredCount} / {totalCount} {t('list.N_FILTERED')}
            </span>
          )}
        </div>
        <div
          className={classNames('starter-list-header-icon-button', {
            active: isSortOpen && isOpen,
          })}
          {...onClickGenerator((event) => {
            event.stopPropagation();
            onToggleSort();
          })}
        >
          <i className="fas fa-sort-amount-down" />
        </div>
        {hasAvailableTags && (
          <div
            className={classNames('starter-list-header-icon-button', {
              active: isFilterOpen && isOpen,
            })}
            {...onClickGenerator((event) => {
              event.stopPropagation();
              onToggleFilter();
            })}
          >
            <i className="fas fa-filter" />
          </div>
        )}
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
